import { Injectable } from '@angular/core';
import { addIcons } from 'ionicons';
import * as allIonicons from 'ionicons/icons';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private loaded = false;
  private availableIconSet = new Set<string>();
  private readonly iconAliases: Record<string, string> = {
    tooth: 'medical',
    'tooth-outline': 'medical-outline',
    'tooth-sharp': 'medical-sharp'
  };

  constructor() {
    this.registerAllIcons();
  }

  async loadAllIcons(): Promise<void> {
    this.registerAllIcons();
  }

  getAvailableIcons(): string[] {
    return Array.from(this.availableIconSet);
  }

  private normalizeIconName(key: string): string {
    return key
      // Insert hyphen before a capital that follows a lowercase letter or digit
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      // Insert hyphen before a capital that is followed by a lowercase letter
      // and preceded by another capital (handles acronyms like "addIOS" → "add-ios")
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
      .toLowerCase();
  }

  private registerAllIcons(): void {
    if (this.loaded) {
      return;
    }

    const normalizedIcons = Object.fromEntries(
      Object.entries(allIonicons)
        .filter(([, value]) => typeof value === 'string')
        .map(([key, value]) => [this.normalizeIconName(key), value])
    ) as Record<string, string>;

    addIcons(normalizedIcons);
    this.availableIconSet = new Set(Object.keys(normalizedIcons));
    this.loaded = true;
  }
}
